var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" © Copyright "+_vm._s(_vm.currentFullYear)+" "+_vm._s(_vm.companyName)+" - Todos os direitos reservados. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }